import React__default from 'react';

const DragAndDropContext = /*#__PURE__*/React__default.createContext({
  isDragging: false,
  isTouchDevice: false,
  setIsDragging() {
    throw new Error('DragAndDropContext is undefined. Make sure you set the `usesSortableLibrary` feature to `true` on the `online-store-ui` <AppProvider /> component');
  }
});

export { DragAndDropContext };
